import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import { RecommendedCountryCarousel } from '@lt/components';

// Selectors:
// import { pushExploreLinkClicked } from 'src/routes/SeoApp/utils/gtmEvents';
import {
  getLinkedRecommended,
  getLinkedCountries,
} from '../../domain/state/linked/selectors';

// PropTypes:
import { LINKED_RECOMMENDED, LINKED_COUNTRY } from './prop-types/linked';

// Context:
import { MobileContext } from '../../domain/context/MobileContext';

const mapStateToProps = (state) => ({
  linkedRecommended: getLinkedRecommended(state),
  linkedCountries: getLinkedCountries(state)?.map((item) => ({
    ...item,
    // onClick: () => {
    //   pushExploreLinkClicked({
    //     custom_params: { type: 'recommendation' },
    //   });
    // },
  })),
});

export const RecommendationContainer = connect(mapStateToProps)((props) => {
  const isMobile = useContext(MobileContext);
  const { linkedRecommended, linkedCountries } = props;

  if (isEmpty(linkedRecommended) && isEmpty(linkedCountries)) {
    return null;
  }

  return (
    <StyledContainer>
      <StyledRecommended
        isMobile={isMobile}
        recommendations={linkedRecommended}
        countries={linkedCountries}
      />
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  margin-top: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
`;

const StyledRecommended = styled(RecommendedCountryCarousel)`
  margin-bottom: 0;
`;

RecommendationContainer.defaultProps = {
  isMobile: false,
};

RecommendationContainer.propTypes = {
  linkedRecommended: LINKED_RECOMMENDED.isRequired,
  linkedCountries: LINKED_COUNTRY.isRequired,
  isMobile: PropTypes.boolean,
};
